import { render, staticRenderFns } from "./ChannelsVoice.vue?vue&type=template&id=e0852c2e"
import script from "./ChannelsVoice.vue?vue&type=script&lang=js"
export * from "./ChannelsVoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports